export interface FilterOption {
    label: string
    value: string
}
export enum FilterType {
    CHECKLIST = 'checklist',
    AUTOCOMPLETE_CHECKLIST = 'autocomplete_checklist',
    FREE_SEARCH = 'free_search',
    DATE_PICKER = 'date_picker',
    SELECT = 'select',
}

export interface FilterPopoverProps {
    label: string
    labelParts?: string[]
    options?: FilterOption[]
    selectedItems?: string[]
    onChange: (value: string) => void
    filterType: FilterType
    placeholder?: string
    hideIndicator?: boolean
}